import LoadingGif from './LoadingGif'

export default LoadingGif
